// ======================================================================
// File Name       : ReservedEmailAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as emailActionCreators from './actionCreators/email';
import * as mailRequest from './httpRequests/email';

export function getReservedEmailList(param) {
  return async (dispatch, getState) => {
    const reservedEmailList = await mailRequest.postReservedEmailList(param);
    return dispatch(emailActionCreators.getReservedEmailList(reservedEmailList));
  };
}

export function getReservedEmailDetail(emailSenderIdAuto) {
  return (dispatch, getState) => {
    const reservedList = getState().reservedEmail.reservedEmailList;
    emailSenderIdAuto = !isNaN(emailSenderIdAuto) ? parseInt(emailSenderIdAuto, 10) : emailSenderIdAuto;
    if (!reservedList || !reservedList.length) {
      const param = {
        searchInfo: {
          emailSenderIdAuto,
        },
      };
      dispatch(getReservedEmailList(param)).then(() => {
        dispatch(emailActionCreators.getReservedEmailDetail(emailSenderIdAuto));
      });
    } else {
      dispatch(emailActionCreators.getReservedEmailDetail(emailSenderIdAuto));
    }
  };
}
